import { ApplicationsConfigurationsServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/applications_configurations/Applications_configurationsServiceClientPb';
import {
  IOSTokenConfiguration,
  AndroidConfiguration,
  ChromeConfiguration,
  EmailConfiguration,
  XiaomiConfiguration,
  HuaweiConfiguration,
  SafariConfiguration,
  ConfigurationRequest,
  ConfigurationResponse,
  EnablePlatformRequest,
  EnablePlatformResponse,
} from '@pushwoosh/rpc-service-client/pushwoosh/applications_configurations/applications_configurations_pb';

export type ApplicationsConfigurationsExportClasses = {
  ApplicationsConfigurationsServiceClient: typeof ApplicationsConfigurationsServiceClient;
  IOSTokenConfiguration: typeof IOSTokenConfiguration,
  AndroidConfiguration: typeof AndroidConfiguration,
  ChromeConfiguration: typeof ChromeConfiguration,
  EmailConfiguration: typeof EmailConfiguration,
  XiaomiConfiguration: typeof XiaomiConfiguration,
  HuaweiConfiguration: typeof HuaweiConfiguration,
  SafariConfiguration: typeof SafariConfiguration,
  ConfigurationRequest: typeof ConfigurationRequest,
  ConfigurationResponse: typeof ConfigurationResponse,
  EnablePlatformRequest: typeof EnablePlatformRequest,
  EnablePlatformResponse: typeof EnablePlatformResponse,
};

export const applicationsConfigurations: ApplicationsConfigurationsExportClasses = {
  ApplicationsConfigurationsServiceClient,
  IOSTokenConfiguration,
  AndroidConfiguration,
  ChromeConfiguration,
  EmailConfiguration,
  XiaomiConfiguration,
  HuaweiConfiguration,
  SafariConfiguration,
  ConfigurationRequest,
  ConfigurationResponse,
  EnablePlatformRequest,
  EnablePlatformResponse,
};
